export const SCROLL_LYRIC_DEFAULTS = {
    scrollLyricLog: '',
    scrollLyricByAnchor: false,
    scrollLyricIndex: -1,
    scrollLyricAlways: false,
    isScrollLyricForSongSelect: false,
    isAutoScrollLyricForPlay: false,
    isScrollLyricForVerseSelect: false,
}
